import { getFeature } from 'Cloud/Application/FeaturesEs6';
import config from 'Cloud/config';
import { HIDE_ADS } from 'reactApp/appHelpers/configHelpers';

// CLOUDWEB-19446
// Реализовать фуллскрины в облаке

/** Аукционный фулскрин - Id 3promo промки, которая будет управлять фулскрином */
export const ADV_AUCFULL_3PROMO_ID = 'adv-aucfull';

/** Аукционный фулскрин - Название рекламного placement (для рекламных радаров) */
export const ADV_AUCFULL_PLACE_NAME = 'aucfull';

/** id dom элемента, в который монтировать фулскрин */
export const DOM_ID_ADV_AUC_FULLSCREEN: string = config.get('DOM_ID_ADV_AUC_FULLSCREEN') || 'adv-aucfull';

/** Аукционный фулскрин - слот */
export const advAucfullSlot: number | undefined = getFeature('adv-aucfull-slot');

/** Аукционный фулскрин - интервал показа в сек */
export const advAucfullShowInterval: number = getFeature('adv-aucfull-show-interval') || 43200;

/** Аукционный фулскрин - время, за которое считаем что фулскрин успеет догрузиться и покзаться (тк логика его работы в РБ) */
export const advAucfullMaxRenderTime: number = getFeature('adv-aucfull-max-render-time') || 5000;

/** Аукционный фулскрин - время, за которое считаем что запрос на ручку adp выполнится для промисификации (сейчас запросы через ajax и колбэки) */
export const advAucfullMaxFetchTime: number = getFeature('adv-aucfull-max-fetch-time') || 5000;

/** Включен ли аукционный фулскрин */
export const advAucfullEnabled: boolean = getFeature(`3promo-enable-${ADV_AUCFULL_3PROMO_ID}`) && advAucfullSlot && !HIDE_ADS;

/** Сколько мс с момента открытия/возвращения во вкладку мы готовы пытаться покзаывать фулскрин */
export const advAucfullMaxTestDelay: number = getFeature('adv-aucfull-max-test-delay') || 5000;

/** Включение сбора перформанс метрик рекламного фулскрина */
export const advAucfullPerfLogEnabled: boolean = getFeature('adv-aucfull-perflog-enabled');

/** Отдельный выключатель для фулскрина на мобильной версии, на случай неустановленных траблов */
export const advAucfullMobileAllowed: boolean = getFeature('adv-aucfull-mobile-allowed');
